// extracted by mini-css-extract-plugin
module.exports = {"tbody":"HomePage_tbody__2wECY","employees-container":"HomePage_employees-container__1vJoE"};